export const REGISTRATION_INELIGIBLE_PATH = "/registration-ineligible";

function findAllowedQuestion(nodes) {
  if (!Array.isArray(nodes)) return null;

  for (const node of nodes) {
    if (!node || typeof node !== "object") continue;
    if (node.name && Array.isArray(node.allowedCategories) && node.allowedCategories.length > 0) {
      return node;
    }

    const nested = findAllowedQuestion(node.elements)
      || findAllowedQuestion(node.questions)
      || findAllowedQuestion(node.templateElements);
    if (nested) return nested;
  }
  return null;
}

const hasCategoryValue = (value) => {
  if (Array.isArray(value)) return value.some((item) => item != null && item !== "");
  return value != null && value !== "";
};

export function selectedAllowedCategory(surveyJson, answers) {
  const question = findAllowedQuestion(surveyJson?.pages);
  if (!question || !hasCategoryValue(answers?.[question.name])) return null;
  return answers[question.name];
}

export function isVisitorCategoryAllowed(surveyJson, answers, fallbackValue) {
  const question = findAllowedQuestion(surveyJson?.pages);
  if (!question) return true;

  const allowed = question.allowedCategories.map(String);
  const selected = hasCategoryValue(answers?.[question.name])
    ? answers[question.name]
    : hasCategoryValue(fallbackValue)
      ? fallbackValue
      : undefined;
  const values = (Array.isArray(selected) ? selected : [selected])
    .filter((value) => value != null && value !== "")
    .map(String);

  return values.length > 0 && values.every((value) => allowed.includes(value));
}
